<template>
    <div id="modal-reprocessa-nps" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog mt-lg-10  modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 id="ModalLabel" class="modal-title">
                        Reprocessar NPS
                    </h5>
                </div>
                <div class="modal-body" v-if="!isLoading">
                    <div class="alert alert-info">
                        <b>Reprocessar tickets NPS para o Movidesk!</b>
                        <p>Informe a data do NPS finalizado que deseja reprocessar.</p>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <label>Data Final NPS</label>
                            <datepicker v-model="dataReprocessamento" minimum-view="day"
                                class="form-control text-bold text-center date-input" :locale="locale"
                                input-format="dd/MM/yyyy" placeholder="DD/MM/AAAA" />

                        </div>
                    </div>
                    
                </div>
                <div class="modal-footer" v-if="!isLoading">
                    <button type="button" class="btn bg-gradient-primary btn-sm" @click="reprocessarNPS()">
                        <i class="fas fa-retweet"></i> 
                        Reprocessar
                    </button>

                    <button type="button" class="btn bg-gradient-dark btn-sm" data-bs-dismiss="modal">
                        Fechar
                    </button>
                </div>
                <div class="loading-div" v-if="isLoading">
                    <span class="mb-4">
                        Aguarde um momento, reprocessando NPS ...
                    </span>
                    <i class="fas fa-spinner fa-pulse fa-3x"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { successToast, errorToast } from '@/utils/alerts';
import Datepicker from 'vue3-datepicker';
import * as moment from 'moment';
import api from "@/services/api";

export default {
    name: "ModalReprocessaNPS",
    components: {
        Datepicker
    },
    data() {
        return {
            dataReprocessamento: moment().toDate(),
            isLoading: false
        }
    },
    methods: {
        reprocessarNPS() {
            if(!this.dataReprocessamento) {
                errorToast('Informe uma data válida para reprocessar o NPS');
                return;
            }

            this.$swal.fire({
                title: 'Tem certeza disso?',
                text: "O reprocessamento do NPS irá criar todos os ticket's no Movidesk. Deseja continuar?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, reprocessar!',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading = true;

                    api.post(`/nps/reprocessar/nps`, {dataRepro: moment(this.dataReprocessamento).format('YYYY-MM-DD')}).then(({ data }) => {
                        if(data.status == false) {
                            errorToast(data.mensagem);
                            this.isLoading = false;
                            return;
                        }

                        successToast('NPS reprocessado com sucesso!');
                        this.isLoading = false;

                    }).catch((error) => {
                        errorToast(error.data.message ?? 'Erro ao reprocessar NPS');
                        this.isLoading = false;
                    });
                    
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .loading-div {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        font-size: 1.5rem;
        flex-direction: column;
    }

    .alert-info {
        color: #fff !important;
    }
</style>